"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var graph_1 = require("../../utils/graph");
var Legend = function (_a) {
    var plots = _a.plots, className = _a.className;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("ui-theme ui-legend", className) }, plots.map(function (plot) { return (react_1.default.createElement("div", { key: plot.label, className: "ui-legend-plot" },
        react_1.default.createElement("span", { className: "ui-legend-box", style: {
                borderStyle: plot.dashed ? 'dashed' : 'solid',
                borderColor: (0, graph_1.getPlotColor)(plot.color),
            } }),
        react_1.default.createElement("span", { className: "ui-legend-label" }, plot.label))); })));
};
exports.default = Legend;
